/* global define, module */
(function () {
  var keyboardeventKeyPolyfill = {
    polyfill: polyfill,
    keys: {
      3: 'Cancel',
      6: 'Help',
      8: 'Backspace',
      9: 'Tab',
      12: 'Clear',
      13: 'Enter',
      16: 'Shift',
      17: 'Control',
      18: 'Alt',
      // This (keyCode 19) needs to stay as Pause and not as MediaPause although admitted it would make
      // more sense to use MediaPause in a HbbTV context - 19 is a common standard code wordlwide
      // @see: https://www.w3.org/TR/uievents-key/#keys-ui
      19: 'Pause',
      20: 'CapsLock',
      27: 'Escape',
      28: 'Convert',
      29: 'NonConvert',
      30: 'Accept',
      31: 'ModeChange',
      32: ' ',
      33: 'PageUp',
      34: 'PageDown',
      35: 'End',
      36: 'Home',
      37: 'ArrowLeft',
      38: 'ArrowUp',
      39: 'ArrowRight',
      40: 'ArrowDown',
      41: 'Select',
      42: 'Print',
      43: 'Execute',
      44: 'PrintScreen',
      45: 'Insert',
      46: 'Delete',
      48: '0',
      49: '1',
      50: '2',
      51: '3',
      52: '4',
      53: '5',
      54: '6',
      55: '7',
      56: '8',
      57: '9',
      91: 'OS',
      93: 'ContextMenu',
      106: '*',
      107: '+',
      109: '-',
      110: '.',
      111: '/',
      144: 'NumLock',
      145: 'ScrollLock',
      170: 'Search',
      179: 'MediaPlayPause',
      181: 'VolumeMute',
      182: 'VolumeDown',
      183: 'VolumeUp',
      186: ';',
      187: '=',
      188: ',',
      189: '-',
      190: '.',
      191: '/',
      192: '`',
      219: '[',
      220: '\\',
      221: ']',
      222: "'",
      224: 'Meta',
      225: 'AltGraph',
      227: 'MediaRewind',
      228: 'MediaFastForward',
      246: 'Attn',
      247: 'CrSel',
      248: 'ExSel',
      249: 'EraseEof',
      250: 'Play',
      251: 'ZoomOut',
      403: 'ColorF0Red',
      404: 'ColorF1Green',
      405: 'ColorF2Yellow',
      406: 'ColorF3Blue',
      412: 'MediaRewind',
      413: 'MediaStop',
      415: 'MediaPlay',
      417: 'MediaFastForward',
      457: 'Info',
      461: 'Backspace',
      463: 'MediaPlayPause',
      502: 'ColorF2Yellow',
      10009: 'Backspace', // Samsung 2022
      10252: 'MediaPlayPause' // Samsung 2022
    }
  }

  // Function keys (F1-24).
  var i
  for (i = 1; i < 25; i++) {
    keyboardeventKeyPolyfill.keys[111 + i] = 'F' + i
  }

  // Printable ASCII characters.
  var letter = ''
  for (i = 65; i < 91; i++) {
    letter = String.fromCharCode(i)
    keyboardeventKeyPolyfill.keys[i] = [letter.toLowerCase(), letter.toUpperCase()]
  }

  // Numbers on numeric keyboard.
  for (i = 96; i < 106; i++) {
    letter = String.fromCharCode(i - 48)
    keyboardeventKeyPolyfill.keys[i] = letter
  }

  function polyfill () {
    // Polyfill `key` on `KeyboardEvent` and `KeyEvent`
    var proto = {
      get: function () {
        var code = this.which || this.keyCode

        return keyboardeventKeyPolyfill.keys[code] || 'Unidentified'
      },
      enumerable: true,
      configurable: true
    }
    try {
      /* istanbul ignore else */
      if (global.KeyboardEvent) {
        Object.defineProperty(global.KeyboardEvent.prototype, 'key', proto)
        // Need to set code attribute as well, as SAMSUNG UE - 32K5579 (2016)
        // already defines the key attribute for KeyboardEvent events.
        // However that specific TV sets empty string instead of 'Backspace'
        // for keyCode 461
        Object.defineProperty(global.KeyboardEvent.prototype, 'code', proto)
      }
    } catch (error) { }
    try {
      /* istanbul ignore else */
      if (global.KeyEvent) {
        Object.defineProperty(global.KeyEvent.prototype, 'key', proto)
        // @see comment block in previous condition
        Object.defineProperty(global.KeyEvent.prototype, 'code', proto)
      }
    } catch (error) { }
  }

  // @TODO: This could be packed as ES6 module
  /* istanbul ignore next */
  if (typeof define === 'function' && define.amd) {
    define('keyboardevent-key-polyfill', keyboardeventKeyPolyfill)
  } else if /* istanbul ignore next */
    (typeof exports !== 'undefined' && typeof module !== 'undefined') {
    module.exports = keyboardeventKeyPolyfill
  } else if /* istanbul ignore next */
    (window) {
    window.keyboardeventKeyPolyfill = keyboardeventKeyPolyfill
  }
})()
